const styleQuizEvents = {
  action: "style-quiz-event",
  labels: {
    redo: `dashboard:redo`,
    geomagicalLink: `dashboard:geomagical-link`,
    close: `close`,
    complete: `complete`,
    results: {
      geomagicalLink: (styleIndex) => `results:${styleIndex}:geomagical-link`,
      product: {
        addToCart: (styleGroup, productId) =>
          `results:${styleGroup}:product:addtocart:${productId}`,
        addToFavourites: (styleGroup, productId) =>
          `results:${styleGroup}:product:favourites:${productId}`,
        click: (styleGroup, productId) =>
          `results:${styleGroup}:product:click:${productId}`,
      },
      showMore: (styleGroup) => `results:${styleGroup}:products:showmore`,
      shuffle: (styleIndex) => `results:${styleIndex}:products:shuffle`,
      showProductSet: (styleIndex, productSetIndex) =>
        `results:${styleIndex}:show-product-set:${productSetIndex}`,
    },
    selectOption: (slideIndex, styleGroup, placementIndex) =>
      `option:${slideIndex}-${styleGroup}-${placementIndex}`,
    start: (clickSource) => `start:${clickSource}`,
  },
};

export default styleQuizEvents;
